// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"b119e4b6","769":"b678bb22"}[chunkId] + ".chunk.js";
};